import * as React from "react"
import { Box, Button, Drawer } from "@mui/material"
import { HiArrowCircleLeft } from "react-icons/hi"

import useDisclosure from "hooks/useDisclosure"

export default function SecondaryMobileDrawer({
  children,
}: {
  children: React.ReactNode
}) {
  const drawerDisclosure = useDisclosure()
  return (
    <>
      <Box
        sx={{
          display: { xs: "block", sm: "none" },
          displayPrint: "none",
          position: "fixed",
          right: 12,
          bottom: 52,
          zIndex: 99,
          paddingBottom: `env(safe-area-inset-bottom, 0.5rem)`,
        }}
      >
        <Button
          onClick={drawerDisclosure.onOpen}
          size="large"
          sx={{
            px: 0,
            color: "gray.700",
            backgroundColor: "background.paper",
            "&:hover, &:focus, &:active": {
              backgroundColor: "gray.100",
            },
            boxShadow: 2,
            borderRadius: 99,
            minWidth: "inherit",
            width: 48,
            height: 48,
          }}
        >
          <HiArrowCircleLeft size={36} />
        </Button>
      </Box>
      <Drawer
        anchor="left"
        open={drawerDisclosure.isOpen}
        onClose={drawerDisclosure.onClose}
        disablePortal={true}
      >
        <Box
          sx={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            maxWidth: "100vw",
            width: "fit-contents",
            gap: 2,
          }}
        >
          {children}
        </Box>
      </Drawer>
    </>
  )
}
